import React from "react";
import Table from "react-bootstrap/Table";

import { dmyString } from "../../helper";

export default function RunTableList(props) {
  const runTableRows = []

  for (const dailyRun of props.daily_runs) {
    for (const run of dailyRun.runs) {
      runTableRows.push(
        <tr key={run.id}>
          <td>{dmyString(dailyRun.date)}</td>
          <td>{run.pickUpId ? run.pickUp.number : ""}</td>
          <td>{run.dropOffId ? run.dropOff.number : ""}</td>
          <td>{run.complete ? "Complete" : "Incomplete"}</td>
        </tr>
      )
    }
    if (dailyRun.runs.length === 0) {
      runTableRows.push(
        <tr key={"daily_" + dailyRun.id}>
          <td>{dmyString(dailyRun.date)}</td>
          <td></td>
          <td></td>
          <td>Incomplete</td>
        </tr>
      )
    }
  }

  return (
    <div className="runs-table-list">
      <h4>Runs</h4>
      <Table hover className="">
        <thead>
          <tr>
            <th>Date</th>
            <th>Pickup Container</th>
            <th>Dropoff Container</th>
            <th>Completed</th>
          </tr>
        </thead>
        <tbody>
          {runTableRows}
        </tbody>
      </Table>
    </div>
  );
}
